import { useState, useEffect } from "react"

import { CreateMarketplaceLoanResponse, CreateMarketplaceLoanRequest } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

export const useCreateMarketplaceLoan = (selectedOptionUuid: string | null, cartId: string | null, cartTotal: number | null) => {
  const [loanResponse, setLoanResponse] = useState<CreateMarketplaceLoanResponse | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const createLoan = async () => {
      if (selectedOptionUuid && cartId && cartTotal !== null) {
        setIsLoading(true)
        setError(null)
        try {
          const request: CreateMarketplaceLoanRequest = {
            cartId,
            repaymentOptionUuid: selectedOptionUuid,
            amount: {
              amountE5: cartTotal * 1000, //Todo: make this explicit
              currencyCode: "MXN",
            },
          }
          const response = await neloApiClient.createMarketplaceLoan(request)
          setLoanResponse(response)
        } catch (err) {
          setError(err instanceof Error ? err : new Error("An unknown error occurred"))
        } finally {
          setIsLoading(false)
        }
      }
    }

    createLoan()
  }, [selectedOptionUuid, cartId, cartTotal])

  return { loanResponse, isLoading, error }
}
